<template>
    <div class="user">
        <avatar :size="50" :src="user.picture" :username="user.name" />
        <div class="valuer-info">
            <h4>{{ user.name }}</h4>
            <span v-if="date">
                <nobr
                    >{{ date | formatDate }}
                    <nobr v-if="isArchived">
                        | {{ $t('talk.feedback.status.archived') }}
                    </nobr>
                </nobr>
            </span>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import Avatar from 'vue-avatar'

export default {
    name: 'User',
    components: {
        Avatar,
    },
    props: {
        user: Object,
        date: String,
        archived_at: [Date, null],
    },
    filters: {
        formatDate: function(value) {
            if (!value) return ''
            value = value.toString()
            return moment(value).format('DD/MM/YYYY')
        },
    },
    computed: {
        isArchived() {
            return this.archived_at != null
        },
    },
}
</script>

<style lang="sass" scoped>
.user
    display: flex
    align-items: flex-start
    width: auto
    .vue-avatar--wrapper
        margin: 0 10px
    .valuer-info
        display: flex
        flex-direction: column
        justify-content: center
        color: #6A6B6B
        min-height: 50px
        min-width: 200px
        word-wrap: break-word
        white-space: pre-wrap
        white-space: -moz-pre-wrap
        white-space: -pre-wrap
        white-space: -o-pre-wrap
        h4
            font-size: 18px
            margin: 0
        span
            font-size: 12px
@media (min-width: 992px)
    .user
        .valuer-info
            width: 290px
    .user-right
        margin-left: 20px
</style>
